var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimulator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 100,
    viewBox: "0 0 113 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0449 53.0448L40.042 33.8884V1.72168H2.41583V33.8884L18.4129 53.0448H24.0449ZM7.28081 6.57062H35.1692V32.1357L21.225 48.829L7.28081 32.1357V6.57062Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.28473,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2393 96.3842L111.236 77.2277V45.061H73.618V77.2277L89.6151 96.3842H95.247H95.2393ZM78.483 49.91H106.371V75.475L92.4272 92.1684L78.483 75.475V49.91Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.28473,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0618 52.3113V95.7562H95.0083",
    stroke: "black",
    strokeWidth: 8.09984,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulator);
export default __webpack_public_path__ + "static/media/Simulator.bf5907bc.svg";
export { ForwardRef as ReactComponent };